const UnlimitedBadge = () => {
  return (
    <div
      className={
        'inline-flex items-baseline rounded-full bg-blue-100 px-2.5 py-0.5 text-sm font-medium ' +
        'text-blue-800 md:mt-2 lg:mt-0'
      }
    >
      Ilimitado
    </div>
  )
}

export default UnlimitedBadge
